import { FC } from 'react';
import { LogoutOutlined } from '@ant-design/icons';
import { CustomTooltip } from '@mybonum/ui';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Button } from 'antd';
import clsx from 'clsx';

import styles from './styles.module.scss';

import { useSidebarContext } from '@/contexts/sidebar';
import { API } from '@/services/api';

export const Logout: FC = () => {
    const queryClient = useQueryClient();
    const { collapsed } = useSidebarContext();

    const { mutateAsync: logout, isPending } = useMutation({
        mutationFn: async () => {
            await API.AUTH.logout();
            await queryClient.invalidateQueries({
                queryKey: API.AUTH.authCheck().queryKey,
            });
        },
    });

    const button = (
        <Button
            className={clsx(styles.button, { [styles.collapsed]: collapsed })}
            color="danger"
            loading={isPending}
            variant="text"
            onClick={async () => {
                await logout();
            }}
            icon={<LogoutOutlined />}
        >
            {!collapsed && 'Log Out'}
        </Button>
    );

    if (collapsed) {
        return <CustomTooltip title="Log Out">{button}</CustomTooltip>;
    }

    return button;
};
